import React, { Component, createRef } from "react";
import './styles.scss';
import { generateKey } from "../../../infrastructure/helpers/react/commonHelper";
import OutsideClickDetector from "../OutsideClickDetector";
import Spinner from "../Spinner/Spinner";
import CustomIcon from "../BootstrapIcons/Custom/CustomIcon";
import { ReactComponent as ChevronIcon } from '../BootstrapIcons/caret-down.svg';
import CustomDropdownOption from "./CustomDropdownOption";

interface Props {
    onOptionSelected: (option: CustomDropdownOption) => void;
    value: string;
    onClick?: () => void;
    containerClassName?: string;
    getOptions: () => Promise<CustomDropdownOption[]>;
    showOnlyDefaultTextAsSelected?: string;
    optionsAsHiperlinks?: boolean;
}

interface State {
    open: boolean;
    options: CustomDropdownOption[];
    showSpinner: boolean;
}

class CustomDropdown extends Component<Props, State> {

    private dropdownRef = createRef<HTMLDivElement>();

    constructor(props: Props) {
        super(props);

        this.state = {
            open: false,
            options: [],
            showSpinner: false
        }

        this.selectOption = this.selectOption.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    async onClick() {

        this.setState({ showSpinner: true });

        let options = await this.props.getOptions();

        if (!options.length) {
            this.setState({ open: false, showSpinner: false });
        }
        else {
            this.setState({ open: true, options, showSpinner: false });
        }
    }

    selectOption(option: CustomDropdownOption) {
        this.props.onOptionSelected(option);
    };

    render() {
        return (
            <OutsideClickDetector onClickOuside={() => this.setState({ open: false })}>
                <div className='display-flex align-items-center'>
                    <div className={`select-container ${this.props.containerClassName || ''}`} ref={this.dropdownRef} onClick={this.onClick}>
                        <div className='display-flex align-items-center' onClick={this.onClick} >
                            <div className='select'>
                                <span className="custom-dropdown-header">
                                    {this.props.showOnlyDefaultTextAsSelected}
                                </span>
                            </div>
                            <CustomIcon className='dropdown-caretDown' icon={ChevronIcon} />
                            {this.state.showSpinner && <Spinner />}
                        </div>
                        {this.state.open &&
                            <ul className={`dropdown-list ${this.props.containerClassName || ''}`}>
                                {this.state.options.map((option) => {
                                    return <li key={generateKey()}
                                        className="dropdown-option">
                                        {option.asUrl ?
                                            <span className='url-span' onClick={() => this.selectOption(option)}>{option.component.name}</span>
                                            : <span onClick={() => this.selectOption(option)}>{option.component.name}</span>
                                        }
                                    </li>

                                })}
                            </ul>
                        }
                    </div>
                </div>
            </OutsideClickDetector>
        );
    }
}

export default CustomDropdown;